/* tutor-1 (C): LAS SUGERENCIAS DEBAJO DE LA RESPUESTA: hasta 4 chips de 28 con los del modelo (al tocarlos, el texto
   se manda como mensaje) y "Practicar este tema" en naranja suave SOLO cuando el `fin` trajo `tema`.

   ARCHIVO EN ASCII A PROPOSITO. */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AreaDe44 } from '../panel/anatomia';

const CHIP = 'relative h-7 px-[11px] rounded-full border text-[12.5px] whitespace-nowrap max-w-full transition-colors disabled:opacity-45';

export default function Chips({ chips = [], tema, alTocar, alPracticar, apagados = false, tope = 4 }) {
  const { t } = useTranslation('study');
  // tutor-2 (C.2): a media sesion los chips fijos van antes de los del modelo, y el tope crece con ellos.
  const lista = (chips || []).slice(0, tope);
  if (!lista.length && !tema) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="tutor-chips">
      {lista.map((c, i) => (
        <button key={`${i}-${c}`} type="button" disabled={apagados} onClick={() => alTocar && alTocar(c)}
          className={`${CHIP} border-[#2C2C2C] bg-[#1B1B1B] text-[#C8C8C8] hover:border-[#3a3a3a] hover:text-[#F4F4F3]`}
          data-testid="tutor-chip">
          <AreaDe44 />
          <span className="block truncate">{c}</span>
        </button>
      ))}
      {tema ? (
        <button type="button" disabled={apagados} onClick={() => alPracticar && alPracticar(tema)}
          className={`${CHIP} border-[#3A2414] bg-[#241710] text-[#F7A06A]`} data-testid="tutor-chip-practicar">
          <AreaDe44 />
          <span className="block truncate">{t('tutor.chip.practice')}</span>
        </button>
      ) : null}
    </div>
  );
}
